module.exports = __webpack_public_path__ + "static/media/typescript.3de182d2.svg";